export enum PolicyDiscounts {
  PROPERTY_AUTOPAY = 'HOAFTDisc_af',
  AUTO_AUTOPAY = 'PAAutoPayVehDisc_af'
}
